import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import DayComponent from 'src/components/prepare/DayComponent';
import PrepareBanner from 'src/components/prepare/PrepareBanner';
import PrepareScheduleBanner from 'src/components/prepare/PrepareScheduleBanner';
import Container from 'src/components/shared/Container';
import { useUserContext } from 'src/context/UserProvider';
import { useGetPrepePlanById } from 'src/hooks/prepPlan.hooks';
import { DailyPlanFormat, InterviewPathType, PrepPlanBadgeStatus } from 'types';
import seoConfig from '../seo.json';
import Seo from 'src/components/Seo';

const Prepare = () => {
	const navigate = useNavigate();
	const {
		user,
		hasReschedulableMeeting,
		allowUserToScheduleMeeting,
		hasAvailedAllFreeInterviews,
		isJobseekerLoggedIn,
	} = useUserContext();

	const [prepData, setPrepData] = useState<DailyPlanFormat[]>([]);
	const [disableSchedule, setDisableSchedule] = useState<boolean>(false);
	const [bannerData, setBannerData] = useState<{ streak: number; progress: number }>({ streak: 0, progress: 0 });

	const seoInfo = seoConfig['prep'];
	const isPaidUser =
		user?.evaluation?.interviewPath?.type === InterviewPathType.Paid || user?.evaluation?.interviewPath === undefined;

	const prepPlan = useGetPrepePlanById({
		isJobSeekerLoggedIn: isJobseekerLoggedIn,
		onComplete: data => {
			const prepDataFormatted = data.prepPlan?.dayWisePerformance.map(day => ({
				day: day.day,
				status: day.isLocked
					? PrepPlanBadgeStatus.LOCKED
					: day.isCompleted
						? PrepPlanBadgeStatus.COMPLETED
						: PrepPlanBadgeStatus.IN_PROGRESS,
				questions: day.performance.map(per => per.questionWisePerformance.flat()).flat(),
			}));
			const shouldDisableSchedule =
				((isPaidUser && data.prepPlan?.dayWisePerformance.some(day => !day.isCompleted)) ||
					(!allowUserToScheduleMeeting && !hasReschedulableMeeting && hasAvailedAllFreeInterviews)) ??
				false;
			setDisableSchedule(shouldDisableSchedule);
			setBannerData({ streak: user?.evaluation?.streak || 0, progress: data.percentCompleted || 0 });
			if (prepDataFormatted) setPrepData(prepDataFormatted);
		},
	});
	if (!prepPlan.data?.prepPlan || (!isPaidUser && prepPlan.data.prepPlan.payment === null)) {
		// navigate('/dashboard');
		navigate('/my-applications');
	}

	return (
		<>
			<Seo title={seoInfo.title} description={seoInfo.title} />
			<PrepareBanner bannerData={bannerData} numberOfDays={prepData.length ?? 0} />
			<Container>
				<div className="mx-7 sm:mx-0">
					<DayComponent dailyPlan={prepData} />
				</div>

				<div className="m-6 sm:m-0 sm:mt-6">
					<PrepareScheduleBanner disableSchedule={disableSchedule} />
				</div>
			</Container>
		</>
	);
};

export default Prepare;
